export const chargingPowerTwoDecimal = power => {
  return Math.floor(power * 100) / 100;
};
